<template>
  <div v-if="modalOnly">    
    <portal to="global-modal-portal" v-if="showLoginConfirmation">
      <b-modal :active.sync="showLoginConfirmation" :width="640" scroll="keep" :has-modal-card="true" :canCancel="false">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
              <p class="modal-card-title">Login to CARFAX</p>
          </header>
          <section class="modal-status-body has-background-white">
            <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage"></error-display-component>
            <div class="block has-background-white p-30">
              <div class="notification is-flex is-warning" style="margin: 25px;">
                <span><i class="fas fa-exclamation-triangle is-warning fa-2x"></i></span>
                <span class="ml-10">
                  Do you want to login to CARFAX?
                </span>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-primary" :class="{'is-loading': isSaving }"  @click="loginToCarFax" type="button">Yes</button>
            <button class="button is-danger" @click="closeLoginControl()" type="button">No</button>
          </footer>
        </div>
      </b-modal>
    </portal>
  </div>
  <div v-else>
    <div class="column is-12" v-if="showCarfaxLogin && !currentUserHasValidCarfaxSession && !showLoginConfirmation">
      <button class="button is-info" @click="loginToCarFax()" type="button" :class="{'is-loading': isSaving }">Login to CARFAX</button>
    </div>
    <portal to="global-modal-portal" v-else-if="showLoginConfirmation">
      <b-modal :active.sync="showLoginConfirmation" :width="640" scroll="keep" :has-modal-card="true" :canCancel="false">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
              <p class="modal-card-title">Login to CARFAX</p>
          </header>
          <section class="modal-status-body has-background-white">
            <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage"></error-display-component>
            <div class="block has-background-white p-30">
              <div class="notification is-flex is-warning" style="margin: 25px;">
                <span><i class="fas fa-exclamation-triangle is-warning fa-2x"></i></span>
                <span class="ml-10">
                  Do you want to login to CARFAX?
                </span>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-primary" :class="{'is-loading': isSaving }"  @click="loginToCarFax" type="button">Yes</button>
            <button class="button is-danger" @click="showLoginConfirmation = false" type="button">No</button>
          </footer>
        </div>
      </b-modal>
    </portal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
import appraisalService from '@/services/appraisalService'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import eventBus from '@/eventBus'

const mapDealerState = createNamespacedHelpers('dealer').mapState
const mapUserGetters = createNamespacedHelpers('user').mapGetters

export default {
  name: 'CarFaxLoginControl',
  components: {
    'error-display-component': ErrorDisplayComponent
  },
  props: {
    vinNo: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'CarFax Status'
    },
    inventory: {
      type: Object,
      default: null
    },
    modalContainer: {
      type: Boolean,
      default: false
    },
    modalOnly: {
      type: Boolean,
      default: false
    },
    showLoginModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isRefreshing: false,
      showReport: false,
      isSaving: false,
      loginUrl: '',
      showLoginConfirmation: false,
      currentUserValue: null
    }
  },
  computed: {
    ...mapUserGetters(['currentUser', 'hasFeatureAccess']),
    ...mapDealerState(['currentDealer']),
    currentUserHasValidCarfaxSession: function() {
      if (this.currentUserValue && this.currentUserValue.carFaxSession && this.currentUserValue.carFaxSession.hasValidSession && this.currentUserValue.accessTokenGeneratedOn && this.currentUserValue.accessTokenExpiresIn) {
        let generatedOn = this.currentUserValue.accessTokenGeneratedOn
        let tokenExpirationInMilliseconds = this.currentUserValue.accessTokenExpiresIn * 1000
        let expirationDateTime = new Date(generatedOn + tokenExpirationInMilliseconds)
        var dateTimeNow = new Date()
        if (dateTimeNow < expirationDateTime) {
          return true
        }
      }
      return false
    },
    showCarfaxLogin: function() {
      if (this.currentUserValue && this.currentUserValue.id && this.currentUserValue.id > 0 && (this.vinNo || (this.inventory && this.inventory.vinNo))) {
        return true
      }
      return false
    }
  },
  methods: {
    loginToCarFax: function () {
      let that = this
      this.isSaving = true
      appraisalService.getCarFaxLoginUrl(that.currentUserValue.id).then(response => {
        if (response.errors) {
          that.serverErrors = response.errors
          that.isSaving = false
        } else {
          that.$emit('login-requested')
          that.showLoginConfirmation = false
          that.isSaving = false
          that.downloadUrl = response
          window.open(that.downloadUrl, '_blank')
        }
      }).catch((error) => {
        that.isSaving = false
        that.serverErrorMessage = error.message
      })
    },
    showCarfaxLoginConfirmationModal: function () {
      this.showLoginConfirmation = true
    },
    setCurrentUserValue: function () {
      this.currentUserValue = this.currentUser
    },
    closeLoginControl: function () {
      this.$emit('on-close-login-modal')
      this.showLoginConfirmation = false
    }
  },
  watch: {
    showLoginModal: function (newValue, oldValue) {
      if (newValue) {
        this.showCarfaxLoginConfirmationModal()
      }
    }
  },
  beforeDestroy () {
    eventBus.$off('refresh-current-user', this.setCurrentUserValue)
  },
  mounted () {
    eventBus.$on('refresh-current-user', this.setCurrentUserValue)
    this.currentUserValue = this.currentUser
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .status-icon {
    width: 13px;
    height: 12px;
    margin-right:12px;
  }

  .carfax-container-display-only {
    display: inline-flex;
    flex-flow: row;
    align-items: center;
    margin-top:10px;
  }

  .carfax-container {
    margin-top: 20px;
    padding: 0;
    margin-left:0;
    margin-right:0;
  }

  .carfax-owner-icons {
    height: 12px;
    width: 12px;
    margin-top:-15px;
  }

  .carfax-warning {
    background-image: url('@/assets/static/carfax/ico_accident.png');
    background-repeat: no-repeat, no-repeat;
    margin-top:-15px;
  }

  .carfax-danger {
    background-image: url('@/assets/static/carfax/ico_alert.png');
    background-repeat: no-repeat, no-repeat;
    margin-top:-15px;
  }

  .carfax-recall {
    background-image: url('@/assets/static/carfax/ico_recall.png');
    background-repeat: no-repeat, no-repeat;
    margin-top:-15px;
  }

  .carfax-ok {
    background-image: url('@/assets/static/carfax/ico_green_check.png');
    background-repeat: no-repeat, no-repeat;
    margin-top:-15px;
  }

  .refresh-status-label {
    margin-left:1em;
  }

  .cd .column {
    padding:0;
  }
</style>
